import React from 'react';
import './HeadImage.css';

function HeadImage(props) {
    return (
        <div className="background-image intro-section">
            <div className="container ">
                <div className="pt-5">
                    <br/>
                </div>
                <div className="pt-5 ">
                    <br/>
                </div>
                <div className="row mt-5 py-5">
                    <div className="col-sm-7">
                        <h1><strong>LOVE YOUR FEET PODIATRY</strong></h1>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default HeadImage;